module.exports = __webpack_public_path__ + "static/media/avg-delivery-time-icon.bc23e0b1.svg";